<template>
    <v-layout fill-height row justify-center :class="flexClass">
        <v-progress-linear :indeterminate="true" v-if="progressBarVisible" class="ma-0 pa-0 progress-top"></v-progress-linear>
        <v-flex sm12 md10 lg8 p-0>
            <v-card class="fill-height">
                <v-breadcrumbs :items="breadCrumbs" class="dense">
                    <template v-slot:divider>
                        <v-icon>forward</v-icon>
                    </template>
                </v-breadcrumbs>
                <!--
                <v-card-title>
                    <h2>{{ $t("species") }}</h2>
                    <v-spacer></v-spacer>
                    <v-text-field
                        v-model="speciesSearch"
                        append-icon="search"
                        :label="$t('search')"
                        single-line
                        hide-details
                    ></v-text-field>
                </v-card-title>
                -->

                <v-toolbar card prominent flat dense>
                    <v-tooltip
                        bottom
                        :disabled="true"
                    >
                        <template v-slot:activator="{ on }">
                            <v-btn
                                flat
                                v-on="on"
                                @click="loadSpecies"
                            >
                                <v-icon>mdi-reload</v-icon> {{ $t("reload") }}
                            </v-btn>
                        </template>
                        <span>{{ $t("reload") }}</span>
                    </v-tooltip>

                    <v-tooltip
                        bottom
                        :disabled="true"
                    >
                        <template v-slot:activator="{ on }">
                            <v-btn
                                flat
                                v-on="on"
                                @click="saveSpecies"
                            >
                                <v-icon>mdi-content-save-outline</v-icon> {{ $t("save") }}
                            </v-btn>
                        </template>
                        <span>{{ $t("save") }}</span>
                    </v-tooltip>
                </v-toolbar>

                <v-card-text class="v-scrollable">
                    <v-data-table
                        v-model="selected"
                        :headers="computedHeaders"
                        :items="species"
                        :search="speciesSearch"
                        hide-actions
                        select-all
                        class="dense-table"
                    >
                        <template v-slot:headers="props">
                            <tr>
                                <th>
                                    <v-checkbox
                                        :input-value="props.all"
                                        :indeterminate="props.indeterminate"
                                        primary
                                        hide-details
                                        @click.stop="toggleAll"
                                    ></v-checkbox>
                                </th>
                                <th
                                    v-for="header in props.headers"
                                    :key="header.text"
                                >
                                    {{ header.text }}
                                </th>
                            </tr>
                        </template>
                        <template v-slot:items="props">
                            <tr :active="props.selected" @click="props.selected = !props.selected">
                                <td width="10px">
                                    <v-checkbox
                                        :input-value="props.selected"
                                        primary
                                        hide-details
                                    ></v-checkbox>
                                </td>
                                <td class="text-xs-left">{{ props.item.species }}</td>
                                <!--
                                <td class="justify-center layout px-0">
                                    <v-icon
                                        class="mr-2"
                                        @click="editItem(props.item)"
                                    >
                                        edit
                                    </v-icon>
                                    <v-icon
                                        @click="deleteItemClick(props.item)"
                                    >
                                        delete
                                    </v-icon>
                                </td>
                                -->
                            </tr>
                        </template>
                        <template v-slot:no-results>
                            <v-alert :value="true" color="error" icon="warning">
                                {{ $t("youSearchFor") }}{{ speciesSearch }}{{ $t("foundNoResults") }}.
                            </v-alert>
                        </template>
                    </v-data-table>
                </v-card-text>
            </v-card>
            <message-box ref="MessageBox"/>
            <v-alert
                :value="alert !== ''"
                :type="alertType"
                transition="scale-transition"
                class="bottom-alert"
            >
                {{ alert }}
            </v-alert>
        </v-flex>
    </v-layout>
</template>

<script>
    import MessageBox from "@/components/dialogs/MessageBox";

    export default {
        name: "SpeciesManagement",

        components: {
            MessageBox
        },

        data () {
            return {
                alert: "",
                alertType: "success",

                breadCrumbs: [
                    { text: "Справочники", disabled: false },
                    { text: "Породы",      disabled: false }
                ],
                headers: [
                    { text: "id",     value: "id",      align: "center", sortable: true },
                    { text: "Порода", value: "species", align: "left",   sortable: true },
                    //{ text: "Действие", value: "action",  align: "center", sortable: false }
                ],
                hideIDs: true,
                progressBarVisible: false,
                savePressed: false,
                selected: [],
                species: [],
                speciesSearch: ""
            }

        },

        computed: {
            computedHeaders () {
                if (this.hideIDs) {
                    return this.headers.filter(header => header.text !== "id");
                }

                return this.headers;
            },

            flexClass () {
                return {
                    //lgUp: this.$vuetify.breakpoint.lgAndUp,
                    "md-up": this.$vuetify.breakpoint.mdAndUp
                }
            }
        },

        watch: {
            alert: function (val) {
                let component = this;
                if (val !== "") {
                    setTimeout(() => {
                        component.alert = "";
                    }, 3000);
                }
            }
        },

        mounted () {
            if (!this.$store.getters.user.loggedIn) {
                if (!this.$noRedirect.includes(this.$router.currentRoute.path)) {
                    this.$router.push("/home");
                }
            }

            this.applyLocale();

            this.$root.$on("localeChanged", () => { this.applyLocale(); });

            this.$root.$on("settingsSaved", () => {
                if (this.savePressed) {
                    this.alertType   = "success";
                    this.alert       = this.$i18n.t("settingsSaved");
                    this.savePressed = false;
                }
            });
        },

        methods: {
            /**
             * Применение локали
             */
            applyLocale () {
                this.headers = [
                    { text: "id",                  value: "id",      align: "center", sortable: true },
                    { text: this.$t("speciesAlt"), value: "species", align: "left",   sortable: true },
                    //{ text: this.$t("action"),     value: "action",  align: "center", sortable: false }
                ];

                this.breadCrumbs = [
                    { text: this.$t("catalogs"), disabled: false },
                    { text: this.$t("species"),  disabled: false }
                ];

                this.loadSpecies();
            },

            /*
            deleteItemClick () {
                //this.$debug.log("delete item click");
            },

            editItem () {
                //this.$debug.log("edit item");
            },
            */

            /**
             * Загрузка списка пород
             */
            loadSpecies () {
                this.progressBarVisible = true;

                this.axios.get(`${this.$config.apiURL}species/`, { withCredentials: true })
                    .then(response => {
                        if (response.data.status == "success") {
                            let speciesInfo = response.data.species

                            this.species    = [];

                            speciesInfo.forEach((itemInfo) => {
                                if (itemInfo.Visible) {
                                    this.species.push({
                                        id:      itemInfo.id,
                                        species: this.$t(itemInfo.Name)
                                    });
                                }
                            });

                            this.selected = []
                            this.$store.getters.user.settings.selectedSpecies.forEach((speciesId) => {
                                this.selected.push(this.species.filter(data => data.id == speciesId)[0]);
                            });
                        }

                        this.progressBarVisible = false;
                    })
                    .catch(error => {
                        this.$debug.error(error);

                        this.progressBarVisible = false;

                        if (error.response && error.response.status == 401) {
                            this.$refs.MessageBox.title       = this.$t("error");
                            this.$refs.MessageBox.messageText = this.$t("sessionExpired");
                            this.$refs.MessageBox.dialog      = true;

                            // Удаление наблюдателя если установлен
                            if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                            // Отслеживание нажатия кнопки ok в диалоге
                            this.dialogWatcher = this.$watch(
                                "$refs.MessageBox.dialog",
                                () => { window.location.reload(); }
                            );
                        } else if (error.response && error.response.status == 402) {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadSpeciesData") + ". " + this.$t("subscriptionExpired"));

                            // Удаление наблюдателя если установлен
                            if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                            // Отслеживание нажатия кнопки ok в диалоге
                            this.dialogWatcher = this.$watch(
                                "$refs.MessageBox.dialog",
                                () => { this.$emit("doLogout", true); }
                            );
                        } else if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                            this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                        } else if (error.response && error.response.status == 403) {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadSpeciesData") + ". " + this.$t("accessDenied"));
                        } else {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadSpeciesData"));
                        }
                    });
            },

            /**
             * Сохранение списка выбранных пользователем пород
             */
            saveSpecies () {
                let ids = [];
                this.selected.forEach(item => ids.push(item.id));

                let user = this.$store.getters.user;
                user.settings.selectedSpecies = ids;

                this.savePressed = true;

                this.$store.commit("setUser", user);
                this.$emit("userSettingsChanged", true);
            },

            /**
             * Отображение сообщения
             *
             * @param {string} title       Заголовок
             * @param {string} messageText Текст сообщения
             */
            showMessageBox (title, messageText) {
                this.$refs.MessageBox.title       = title;
                this.$refs.MessageBox.messageText = messageText;
                this.$refs.MessageBox.dialog      = true;
            },

            /**
             * Переключение всех выбранных элементов
             */
            toggleAll () {
                this.selected = this.selected.length
                    ? []
                    : this.species.slice();
                /*
                if (this.selected.length) {
                    this.selected = [];
                } else {
                    this.selected = this.species.slice();
                }
                */
            },
        }
    }
</script>

<style lang="sass" scoped>
    .layout.md-up
        .v-scrollable
            overflow-y: auto
            max-height: calc(100vh - 144px)
</style>
